"use client";
// Imports
import { useState, useEffect } from "react";
import { PrevAndNextButton, ComponentWrapper, Img } from "@/components";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from "@/components/ui/carousel";
import { imageContainerStyles } from "@/lib/utils";

// Hero Slideshow
export function BasicSlideshow({ type, slides }) {
  // Variables
  const [api, setApi] = useState(null);
  const [current, setCurrent] = useState(0);
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!api) {
      return;
    }

    setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap() + 1);

    api.on("select", () => {
      setCurrent(api.selectedScrollSnap() + 1);
    });
  }, [api]);

  // Render
  return (
    <ComponentWrapper type={type}>
      {slides?.length > 1 ? (
        <Carousel
          setApi={setApi}
          className="z-0 overflow-x-hidden rounded-lg pointer-grap"
        >
          <CarouselContent className="mx-0">
            {slides?.map((slide, index) => (
              <CarouselItem key={index} className="relative text-background">
                <div className={imageContainerStyles({ height: "md" })}>
                  <Img
                    data={slide}
                    sizes="(max-width: 1024px) 100vw, 1600px"
                    fill
                  />
                </div>
              </CarouselItem>
            ))}
          </CarouselContent>
          {slides?.length > 1 && (
            <div className="absolute lg:bottom-8 lg:right-4 right-2 bottom-4">
              <PrevAndNextButton
                prevDisabled={current === 1}
                nextDisabled={current === count}
                prev={() => api?.scrollPrev()}
                next={() => api?.scrollNext()}
              />
            </div>
          )}
        </Carousel>
      ) : (
        <div className={imageContainerStyles({ height: "md" })}>
          <Img
            data={slides[0]}
            sizes="(max-width: 1024px) 100vw, 1600px"
            fill
          />
        </div>
      )}
    </ComponentWrapper>
  );
}
